"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _imageCard = _interopRequireDefault(require("./common/image-card"));
var _iconCard = _interopRequireDefault(require("./common/icon-card"));
// TODO: CMS-28892: Remove this import
// eslint-disable-next-line no-unused-vars

// TODO: CMS-28892: Remove this import
// eslint-disable-next-line no-unused-vars

const Root = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Root",
  class: "pl-r1utxy5r"
});
const generateGridAreas = () => Array.from({
  length: 7
}, (_, i) => `
  & .rtb-card:nth-child(${i + 1}) {
    grid-area: card${i + 1};
  }
`).join('');
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c1si209f",
  vars: {
    "c1si209f-0": [({
      cardCount
    }) => cardCount === 7 ? '31.75rem 31.75rem 31.75rem' : '31.75rem 31.75rem'],
    "c1si209f-3": [({
      cardCount
    }) => cardCount === 7 ? '32.75vw 32.75vw 32.75vw' : '32.75vw 32.75vw']
  }
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-h1ji9vz3"
});

// TODO: CMS-28892: Remove all instances of 'cards' prop

/**
 * RTBCardSection Component.
 * @module RTBCardSection
 *
 * @param {Object} props React props
 * @param {String} props.align LTR | RTL Control
 * @param {String} props.trackingName Tracking Name
 * @param {string} props.verticalMargin Vertical Outer Spacing value
 * @param {string} props.verticalPadding Vertical Inner Spacing value
 * @param {Array} props.cards Card Components (remove with CMS-28892)
 * @param {Array} props.children Card Components
 * @returns {React.ReactElement} RTBCardSection Component
 * @public
 */

function RTBCardSection({
  headlineLockup = null,
  align = 'left',
  trackingName,
  verticalMargin = 'small',
  verticalPadding = 'small',
  cards,
  children
}) {
  /* TODO: CMS-28892 remove "cards.length ??" */
  const cardCount = cards?.length ?? (Array.isArray(children) ? children.length : 0);
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    dataCy: "rtb-card-section",
    margin: "small",
    padding: "none",
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding,
    _name: trackingName
  }, headlineLockup ? /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "headline-container"
  }, headlineLockup) : null, /*#__PURE__*/_react.default.createElement(Root, null, /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "card-container",
    cardCount: cardCount,
    "data-align": align
  }, cards || children)));
}
var _default = exports.default = RTBCardSection;
RTBCardSection.propTypes = {
  headlineLockup: _propTypes.default.node,
  align: _propTypes.default.oneOf(['left', 'right']),
  trackingName: _propTypes.default.string,
  cards: _propTypes.default.arrayOf(_propTypes.default.node),
  children: _propTypes.default.arrayOf(_propTypes.default.node),
  ..._boxModelSize.marginProps,
  ..._boxModelSize.paddingProps
};